import Card from 'components/core/AppCard/Card';
import FormControlLabel from 'components/core/FormControlLabel';
import Grid from 'components/core/Grid';
import styled from 'styled-components';

//UNIVERSAL STYLED COMPONENTS ON ONBOARDING FORMS
export const SetupItem = styled(Grid)<{ $noBorderTop?: boolean }>`
  border-top: ${props => props.$noBorderTop ? 'none' : `1px dashed ${props.theme.palette.grey[300]}`};
  margin-top: ${props => props.$noBorderTop ? props.theme.spacing(1) : props.theme.spacing(2)};
  padding-top: ${props => props.$noBorderTop ? '0' : props.theme.spacing(2)} !important;

  & .MuiInputBase-input {
    background-color: #fff;
  }
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  & .MuiTypography-root {
    font-weight: 500;
  }
`;

export const StyledCard = styled(Card)`
  background-color: ${props => props.theme.palette.grey[50]};
`;

export const AvailablePropertyGrid = styled(Grid)`
  background-color: ${props => props.theme.palette.grey[50]};
  border: 1px solid ${props => props.theme.palette.grey[300]};
  border-radius: 3px;
  padding: ${props => props.theme.spacing(1)} ${props => props.theme.spacing(2)} !important;
  margin-bottom: ${props => props.theme.spacing(2)};
`;
